import ResetLocation from './resetLocation';
import { HomeButton } from './homeButton';
import { ZoneBeaconPairing, ZoneBeaconPairingMobile } from './zoneBeaconPairing';
import SalesFlow from './salesFlow/SalesFlow';
import VoidSale from './salesFlow/VoidSale';
import TheftRecovery from './theftRecovery/PluginSetup';
import DownloadLocatorAgreementPDF from './salesFlow/DownloadLocatorAgreementPDF';
import AddAdditionalTags from './salesFlow/AddAdditionalTags';
import DownloadKeysAgreementPDF from './salesFlow/DownloadKeysAgreementPDF';
import ReplaceCustomerLocator from './salesFlow/ReplaceCustomerLocator';
import VehicleTransferLocation from './vehicleTransferLocation/VehicleTransferLocation';
import GenerateBillingReport from './billing/GenerateBillingReport';
import DownloadAddendumPDF from './billing/DownloadAddendumPDF';
import DownloadInvoicePDF from './billing/DownloadInvoicePDF';
import MapKey from './mapKey/MapKey';
import LogUpload from './logUpload/PluginSetup';
import Reconciliation from './locatorReconciliation/PluginSetup';
import HelpCenter from './helpCenter/PluginSetup';
import PositionPendingAction from './positionPending/PositionPendingAction';
import BulkCreatePaymentsAtBilling from './payments/BulkCreatePaymentsAtBilling';
import DownloadBillingCSVs from './billing/DownloadBillingCSVs';
import DownloadBillingSpreadsheet from './billing/DownloadBillingSpreadsheet';
import ExportBillingDeviceCSV from './billing/ExportBillingDeviceCSV';
import ResetLocator from './resetLocator/PluginSetup';
import MarkAsLost from './markAsLost/PluginSetup';
import LostDeviceActions from './lostDevice/PluginSetup';
import Locations from './locations/PluginSetup';
import ChangeVehicleOwnership from './salesFlow/ChangeVehicleOwnership';
// import RemoveFromConsumerNetwork from './removeFromConsumerNetwork/RemoveFromConsumerNetwork'
import PendingSaleMessage from './salesFlow/PendingSaleMessage';
import ReconcileSales from './reconcileSales/ReconcileSales';
import PositionRequest from './positionRequest/PluginSetup';
import PairKeys from './pairKeys/PairKeys';
import ReconcileLost from './reconcileLost/PluginSetup';
import ReconcileJob from './reconcileJob/PluginSetup';
import CreateTripacContract from './createTripacContract/CreateTripacContract';
export default {
  install(molten) {
    molten.addPlugin('Action', PendingSaleMessage);
    molten.addPlugin('Action', ChangeVehicleOwnership);
    molten.addPlugin('Action', VoidSale);
    molten.addPlugin('Action', ReplaceCustomerLocator);
    molten.addPlugin('Action', ResetLocation);
    molten.addPlugin('Action', HomeButton);
    molten.addPlugin('Action', ZoneBeaconPairing);
    molten.addPlugin('Action', ZoneBeaconPairingMobile);
    molten.addPlugin('Action', SalesFlow);
    molten.addPlugin('Action', DownloadLocatorAgreementPDF);
    molten.addPlugin('Action', DownloadKeysAgreementPDF);
    molten.addPlugin('Action', AddAdditionalTags);
    molten.addPlugin('Action', VehicleTransferLocation);
    molten.addPlugin('Action', GenerateBillingReport);
    molten.addPlugin('Action', DownloadAddendumPDF);
    molten.addPlugin('Action', DownloadInvoicePDF);
    molten.addPlugin('Action', PositionPendingAction);
    molten.addPlugin('Action', MapKey);
    molten.addPlugin('Action', BulkCreatePaymentsAtBilling);
    // molten.addPlugin( 'Action', RemoveFromConsumerNetwork )
    molten.addPlugin('Action', ExportBillingDeviceCSV(molten));
    molten.addPlugin('Action', ReconcileSales);
    molten.addPlugin('Action', PairKeys(molten));
    molten.addPlugin('Action', CreateTripacContract);
    LogUpload.install(molten);
    TheftRecovery.install(molten);
    Reconciliation.install(molten);
    PositionRequest.install(molten);
    HelpCenter.install(molten);
    DownloadBillingCSVs.install(molten);
    DownloadBillingSpreadsheet.install(molten);
    ResetLocator.install(molten);
    MarkAsLost.install(molten);
    LostDeviceActions.install(molten);
    Locations.install(molten);
    ReconcileLost.install(molten);
    ReconcileJob.install(molten);
  }
};